import { render, staticRenderFns } from "./newChapter.vue?vue&type=template&id=7259a61b&scoped=true&"
import script from "./newChapter.vue?vue&type=script&lang=js&"
export * from "./newChapter.vue?vue&type=script&lang=js&"
import style0 from "./newChapter.vue?vue&type=style&index=0&id=7259a61b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7259a61b",
  null
  
)

export default component.exports